import React from 'react';
import { Row, Col } from 'react-flexbox-grid'
import moment from 'moment'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem'
import { Link } from 'react-router-dom'

class Item extends React.Component {
    render() {
        return (
            <div {...this.props}>
                {this.props.item.activo &&
                    <div className='containerItemOferta sortable-list'>
                        <div className='containerInfoItem'>
                            {
                                <div className='imgItem'>
                                    {<img className='cucardaOferta' src={this.props.item.pathImagen ? this.props.item.pathImagen : null} onDragStart={(e) => { e.preventDefault(); }} alt="" />}
                                </div>
                            }
                            <div className='infoItem'>
                                <div className='textoOferta'>{this.props.item.nombre.slice(0, 25) + (this.props.item.nombre.length > 25 ? '...' : '')}</div>
                                {(this.props.item.desde && this.props.item.hasta) &&
                                    <Row style={{ marginTop: "1px" }}>
                                        <div className='vigenciaOferta' style={{
                                            backgroundColor: (moment(this.props.today, 'DD-MM-YYYY').isSameOrAfter(moment(this.props.item.desde, 'DD-MM-YYYY'))
                                                &&
                                                moment(this.props.today, 'DD-MM-YYYY').isSameOrBefore(moment(this.props.item.hasta, 'DD-MM-YYYY').add({ hours: 23, minutes: 59, seconds: 59 })))
                                                ?
                                                "#65DD2C" : //Verde
                                                "#DD2C42"  //Rojo
                                        }}>
                                        </div>
                                        <div className='fechasOferta'>{`${moment(this.props.item.desde, 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY')}`} al {`${moment(this.props.item.hasta, 'DD-MM-YYYY HH:mm').add({ hours: 23, minutes: 59, seconds: 59 }).format('DD/MM/YYYY')}`}</div>

                                    </Row>}
                                {/*<div>{`${x.nombreUsuarioRegistro}`}</div>*/}
                                {/* <div>{x.activo === true ? 'Activo' : 'Inactivo'}</div> */}
                            </div>
                        </div>
                        <div className="containerOpciones" id="containerOpciones" onClick={(e) => { e.stopPropagation() }}>
                            <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
                                {popupState => (
                                    <React.Fragment>
                                        <IconButton {...bindTrigger(popupState)}>
                                            <MoreVertIcon />
                                        </IconButton>
                                        <Menu {...bindMenu(popupState)} id="menuOpciones">
                                            <MenuItem id="menuItemVerDetalle">
                                                <Link
                                                    to={{
                                                        pathname: `/Oferta/Editar/${this.props.item.idOferta}`,
                                                        key: Math.random(),
                                                        state: {
                                                            applied: true
                                                        }
                                                    }}
                                                    style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
                                                >
                                                    Ver Detalle
                                                </Link>
                                            </MenuItem>
                                            <MenuItem id="menuItemBorrar" onClick={(...args) => { this.props.handleOnClickBorrar(this.props.item, false); popupState.close(...args); this.render() }}>Borrar</MenuItem>
                                        </Menu>
                                    </React.Fragment>
                                )}
                            </PopupState>
                        </div>

                    </div>}
            </div>
        )
    }
}

export default Item